import React from 'react'
import { Card, Col, Form, Row } from 'react-angle-dashboard-components'
import InfoRow from './InfoRow'
import { IMedicalPlanDTO } from '../../../../services/quote/dto'
import { addUnit, unitStringFromCostShare } from '../../../../utils'
import trashCan from '../../trashCan.svg'

interface IPlanCardProps {
  plan: IMedicalPlanDTO
  checked: boolean
  onClick: (isSelected: boolean) => void
  onEdit?: () => void
  onDelete?: () => void
}

const PlanCard = ({
  plan,
  checked,
  onClick,
  onEdit,
  onDelete
}: IPlanCardProps) => {
  const {
    planName,
    individualInnDeductible,
    individualInnOopMax,
    costShareInnDefault,
    costShareInnPrimaryCare,
    costShareInnSpecialist,
    costShareInnInPatient,
    costShareInnRx1,
    costShareInnRx2,
    costShareInnRx3,
    costShareInnRx4,
    costShareInnDiagnostic,
    costShareInnUrgentCare,
    costShareInnEmergencyRoom
  } = plan

  const innDeductibleText = addUnit(individualInnDeductible, 'money')
  const oopMaxText = addUnit(individualInnOopMax, 'money')
  const defaultText = unitStringFromCostShare(costShareInnDefault)
  const primaryCareText = unitStringFromCostShare(costShareInnPrimaryCare)
  const specialistText = unitStringFromCostShare(costShareInnSpecialist)
  const inPatientText = unitStringFromCostShare(costShareInnInPatient)
  const rx1Text = unitStringFromCostShare(costShareInnRx1)
  const rx2Text = unitStringFromCostShare(costShareInnRx2)
  const rx3Text = unitStringFromCostShare(costShareInnRx3)
  const rx4Text = unitStringFromCostShare(costShareInnRx4)
  const diagnosticText = unitStringFromCostShare(costShareInnDiagnostic)
  const urgentCareText = unitStringFromCostShare(costShareInnUrgentCare)
  const emergencyRoomText = unitStringFromCostShare(costShareInnEmergencyRoom)

  return (
    <Card
      className={`user-select-none ${checked ? 'border-primary' : ''}`}
      style={{ width: 300 }}
      onClick={() => onClick(!checked)}
    >
      <Card.Header className="py-2" style={{ backgroundColor: '#F8F9FA' }}>
        <Col>
          <Row className="d-flex align-items-center justify-content-between max-w-full flex-nowrap ">
            <p
              style={{
                marginBottom: 0,
                fontWeight: 600,
                fontSize: 16,
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                marginRight: 10
              }}
            >
              {planName}
            </p>
            <div className="d-flex align-items-center">
              {onEdit && (
                <i
                  className="icon icon-pencil text-primary fs-12 mr-2"
                  style={{ height: '100%', width: '0.8rem', cursor: 'pointer' }}
                  onClick={(e) => {
                    e.stopPropagation()
                    onEdit()
                  }}
                />
              )}
              {onDelete && (
                <img
                  className="mr-2"
                  src={trashCan}
                  alt="delete"
                  style={{ height: '100%', width: '0.8rem', cursor: 'pointer' }}
                  onClick={(e) => {
                    e.stopPropagation()
                    onDelete()
                  }}
                />
              )}
              <Form.Check className="mb-1" checked={checked} readOnly />
            </div>
          </Row>
          <InfoRow label="INN Deductible" value={innDeductibleText} />
          <InfoRow label="OOP Deductible" value={oopMaxText} />
        </Col>
      </Card.Header>
      <Card.Body className="py-2">
        <Col>
          <Row
            style={{
              fontWeight: 500,
              fontSize: 13,
              marginBottom: 20
            }}
          >
            In-Network Costs
          </Row>
          <InfoRow label="Default" value={defaultText} />
          <InfoRow label="Primary Care" value={primaryCareText} />
          <InfoRow label="Specialist" value={specialistText} />
          <InfoRow label="In Patient" value={inPatientText} />
          <InfoRow
            label="Rx Tier 1/2/3/4"
            value={`${rx1Text}/${rx2Text}/${rx3Text}/${rx4Text}`}
          />
          <InfoRow label="Diagnostic" value={diagnosticText} />
          <InfoRow label="Urgent Care" value={urgentCareText} />
          <InfoRow label="Emergency Room" value={emergencyRoomText} />
        </Col>
      </Card.Body>
    </Card>
  )
}

export default PlanCard
